/* eslint-disable */
import React from 'react';
import './table-layout.css';

interface Props {
  type: number;
}

export function useGetTableLayout({ type }: Props) {
  const tableLayout = (type: number) => {
    switch (type) {
      // for swap shift table
      case 1: {
        return {
          setTableProps: () => {
            return {
              className: 'swap-shift-table',
            };
          },
          tableBodyHeight: '65vh',
        };
      }

      default: {
        return {};
      }
    }
  };

  return { layout: tableLayout(type) };
}
